import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'app-external-link-warning-dialog',
  imports: [MatButtonModule, MatDialogModule, IconComponent],
  templateUrl: './external-link-warning-dialog.component.html',
  styleUrl: './external-link-warning-dialog.component.scss',
})
export class ExternalLinkWarningDialogComponent {}
